import { render, staticRenderFns } from "./workflow.vue?vue&type=template&id=4fc475db&scoped=true"
import script from "./workflow.vue?vue&type=script&lang=js"
export * from "./workflow.vue?vue&type=script&lang=js"
import style0 from "./workflow.vue?vue&type=style&index=0&id=4fc475db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc475db",
  null
  
)

export default component.exports